import compact from 'lodash/compact';
import filter from 'lodash/filter';
import map from 'lodash/map';
import uniq from 'lodash/uniq';

export const getItems = (attributes, category, subCategory = null) => {
  let results = attributes;
  if (category) {
    results = filter(attributes, { category });
  }
  if (subCategory) {
    results = filter(results, { subCategory });
  }
  return results;
};

export const getCategories = (attributes) => {
  return uniq(map(attributes, 'category'));
};

export const getSubCategories = (attributes, category) => {
  const attributesInCategory = filter(attributes, { category });
  const subCategories = map(attributesInCategory, 'subCategory');

  return compact(uniq(subCategories));
};
